import { WORKOUT_ROUTES } from '../constants/routes';

export const WORKOUT_ROUTE_ACCESS = {
  [WORKOUT_ROUTES.PLAN_EDITOR]: { departments: [], roles: [] },
  // Fitness and Nutritionist staff. These routes are not PrivateRoute-wrapped, so
  // a direct URL still renders; this gates the sidebar item, the embedded flow
  // and the client Activity tab's "Add Workout Plan" buttons.
  [WORKOUT_ROUTES.TEMPLATES_LIST]: { departments: ['Fitness', 'Nutritionist'], roles: [] },
  [WORKOUT_ROUTES.TEMPLATES_NEW]: { departments: ['Fitness', 'Nutritionist'], roles: [] },
  [WORKOUT_ROUTES.TEMPLATES_DETAIL]: { departments: ['Fitness', 'Nutritionist'], roles: [] },
  // Reference data is Fitness Manager only (Executive passes every check).
  [WORKOUT_ROUTES.WORKOUT_REFERENCE_DATA]: { departments: ['Fitness'], roles: ['Manager'] },
};

export const WORKOUT_BUTTON_PERMISSIONS = {};

/** Workout feature access — registered in configs/featureAccess. */
export const workoutAccess = {
  id: 'workout',
  routes: WORKOUT_ROUTE_ACCESS,
  buttons: WORKOUT_BUTTON_PERMISSIONS,
};
